export default __webpack_public_path__ + "static/loader-a84c550b0bccd9402f73627ef479be9c.png";